import type { ReactNode } from 'react';

interface ICardFooterProps {
    children: ReactNode;
}

export function CardFooter(props: ICardFooterProps) {
    return <div className="card__footer">{props.children}</div>;
}
